<template>
	<div class="sucess-message">
		<div class="row justify-content-center align-items-center">
			<div class="col-12">
				

				<div  class="d-flex  justify-content-between align-items-center w-100 messageContent" v-if="$parent.message != '' && $parent.response_msg == 'error'">
				    {{$parent.message}}
			        <feather type="x" @click.prevent="hideFunc()"></feather>
				</div>
				<div class="d-flex  justify-content-between align-items-center w-100 messageContent"  v-if="$parent.message != '' && $parent.response_msg == 'success'">
				    {{$parent.message}}
			        <feather type="x" @click.prevent="hideFunc()"></feather>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'MessageComponent',
		data() {
			return { }
		},
		methods:{
			hideFunc(){
				this.$parent.response_msg = ''
				this.$parent.message =''
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/message.vue